import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProposalsPopInput,
    ProposalsPop,
    UpdateProposalsPopInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class ProposalsPopService {
    private amplifyClient = generateClient();
    constructor() {}

    async listProposalsPops(): Promise<ProposalsPop[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProposalsPops
                })
            ).data.listProposalsPops.items;
            if (data) return data as ProposalsPop[];
        } catch (error) {
            console.error('Error finding ProposalsPop:', error);
            return null;
        }
    }

    async createProposalsPop(
        input: CreateProposalsPopInput
    ): Promise<ProposalsPop> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createProposalsPop,
                    variables: {
                        input
                    }
                })
            ).data.createProposalsPop;
            if (date) return date as ProposalsPop;
        } catch (error) {
            console.error('Error creating ProposalsPop:', error);
            return null;
        }
    }

    async updateProposalsPop(
        input: UpdateProposalsPopInput
    ): Promise<ProposalsPop> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProposalsPop,
                    variables: {
                        input
                    }
                })
            ).data.updateProposalsPop;
            if (date) return date as ProposalsPop;
        } catch (error) {
            console.error('Error creating ProposalsPop:', error);
            return null;
        }
    }
}
